<template>
    <div class="row">
        <!-- <div class="loaders--container" v-if="loading">
            <div class="loaders--standard"></div>
        </div> -->

        <div id="ssow-acordion" class="col-12">
            <collapsable
                :title="titles[type]"
                v-for="(ssow, type) in ssows"
                :show="type === 'ssow_statement'"
                :key="type"
                accordion="#ssow-acordion"
            >
                <template v-if="type === 'ssow_statement'" slot="content">
                    <redactor
                        v-model="pdf_body"
                        :config="{
                            formatting: ['p', 'h1', 'h2', 'h3'],
                            buttons: ['format', 'bold', 'italic', 'ul'],
                            plugins: ['fontcolor'],
                            minHeight: '150px'
                        }"
                        name="body"
                    ></redactor><br/>
                    <a class="btn btn-primary" href="javascript:void(0)" v-on:click="savePdfSettings">Save</a>
                </template>

                <template v-if="type !== 'ssow_statement'" slot="content">
					<div v-if="type !== 'risks'">
						<list-item
							v-for="ssow_record in ssow"
							:key="ssow_record.id"
							:active="false"
						>
							<template slot="title">
								{{title(ssow_record)}}
							</template>
							<template slot="center">
								<label class="toggle">
									<input :id="`${ssow_record.id}-${type}`" type="checkbox" :checked="is_active(ssow_record, type)" @change="toggle(ssow_record.id, type, $event)">
									<span class="toggle--slider"></span>
								</label>
							</template>
						</list-item>
					</div>
                    <div
                        class="flex-table--row"
                        v-else
                        v-for="(ssow_records,group) in ssow"
                        :key="group"
                        :active="false"
                    >
                        <div class="flex-table--cell flex-table--cell-grow-always flex-table--cell-break-100">
                            <div class="container mx-0 p-0">

                                <div class="row">
                                    <div class="col-12">
                                        <h5>{{group}}</h5>
                                    </div>
                                </div>
                                <div class="row mb-2" v-for="ssow_record in ssow_records" :key="ssow_record.id">
                                    <div class="col-8">{{title(ssow_record)}}</div>
                                    <div class="col-4 text-right">
                                        <label class="toggle">
                                            <input :id="`${ssow_record.id}-${type}`" type="checkbox" :checked="is_active(ssow_record, type)" @change="toggle(ssow_record.id, type, $event)">
                                            <span class="toggle--slider"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </collapsable>
        </div>
    </div>
</template>

<style>
.redactor-air, .redactor-toolbar {
    z-index: 0 !important;
}
</style>

<script>
    import Collapsable from "../../ListComponent/Collapsable";
    import ListItem from "../../ListComponent/ListItem";
    import Redactor from "../../general_components/Redactor";
    export default {
        name: "ActiveSsowPage",
        components: {ListItem, Collapsable, Redactor},
        props: {
            submitUrl: {
                type: String,
                required: true
            },
            ssowUrl: {
                type: String,
                required: true
            },

            titles: {
                type: Object,
                required: true
            },

            active_ssows: {
                type: Array,
                required: true
            },

            types: {
                type: Object,
                required: true
            },

            companyStyle: {
                type: String,
                required: true
            },

            save_pdf_settings_url: {
                type: String,
                required: true
            },
            ssow_pdf_setting: {
                type: Object,
                required: true
            }
        },

        data(){
            return {
                loading: true,

                pdf_body: null,
                ssows: {},
                current_active_ssows: [],

                currentSsowUrl: '',
                errors: []
            }
        },

        beforeMount() {
            this.pdf_body = this.ssow_pdf_setting ? this.ssow_pdf_setting.body : '';
        },

        mounted() {
            this.currentSsowUrl = this.ssowUrl;

            this.ssows = {...this.types};
            this.current_active_ssows = [...this.active_ssows];

            Object.keys(this.ssows).forEach((item) => {
                if (item !== 'ssow_statement') {
                    this.loadMore(item);
                }
            });
        },

        methods: {
            savePdfSettings(){
            	axios.post(this.save_pdf_settings_url, {body: this.pdf_body})
					.then(() => {
                        Vue.$toast.open({
                            message: 'PDF changes saved successfully',
                            type: 'success'
                        });
                    })
					.catch(error => {
						if(error.response && error.response.data){
                            Vue.$toast.open({
                                message: error.response.data.message,
                                type: 'error'
                            });
						}
					});
			},

            loadMore: function(type){
                this.loading = true;

                axios.get(this.currentSsowUrl.replace('?', type))
                    .then((response) => {
                        this.ssows[type] = response.data;
                        this.loading = false;
                    })
            },

            toggle: function(ssow, type, event){

                if(event.target.checked){
                    this.current_active_ssows.push({
                        ssow_id: ssow.id,
                        ssow_type: type
                    });
                } else {
                    this.current_active_ssows = this.current_active_ssows.filter((active_ssow) => {
                        return !(active_ssow.ssow_type == type && active_ssow.ssow_id == ssow.id);
                    });
                }

                this.save(ssow, type, event.target.checked);
            },

            save: function(ssow, type, is_active){
                this.errors = [];

                axios.post(this.submitUrl.replace('?', type), {
                    ssow_id: ssow,
                    active: is_active
                }).then(() => {
                    // This message was annoying so disable it
                    // toastr.success('Status Changed Successfully');
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    if(error.response.data.message){
                        this.current_active_ssows = this.current_active_ssows.filter((active_ssow) => {
                            return !(active_ssow.ssow_type == type && active_ssow.ssow_id == ssow.id);
                        });

                        document.getElementById(`${ssow}-${type}`)
                                .checked = false;
                    }
                });
            },

            title: function(ssow){
                return ssow.title !== undefined
                    ? ssow.title
                    : ssow.material;
            },

            is_active: function(ssow, type){
                return this.current_active_ssows.some((active_ssow) => {
                    return this.types[type] == active_ssow.ssow_type && ssow.id == active_ssow.ssow_id;
                });
            }
        }
    }
</script>
